



import BidListComponent from "@/components/admin/bid/bidListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "BidListPage",
  components: {
    BidListComponent,
  },
})
export default class BidListPage extends Vue {}
